import type {
	ListBuilderConfiguration,
	MobileCardConfiguration,
} from '../types';
import { createStatementColumns } from './statement.config';

/**
 * Client-embedded statements list (PD-14043) — the client record's
 * Statements tab. Same columns as Sales > Statements minus the customer
 * column (the parent record IS the customer); the tab's queryFn pins
 * clientId, so no filters are exposed. Row click opens the statement
 * detail in the Sales area.
 */
const EMBEDDED_MOBILE_CARD_CONFIG: MobileCardConfiguration = {
	cardLayout: 'zones',
	primaryFields: ['statement-number'],
	heroField: 'amount-due.amount-due-field',
	hiddenFields: ['ending-balance'],
};

export const STATEMENT_CLIENT_EMBEDDED_CONFIG: ListBuilderConfiguration = {
	lists: [
		{
			id: 'default-client-statements',
			cacheTTL: 300000,
			name: 'Statements',
			type: 'default',
			active: true,
			sortOrder: 0,
			columns: createStatementColumns().filter(
				(column) => column.id !== 'client-info',
			),
			mobileCardConfig: EMBEDDED_MOBILE_CARD_CONFIG,
			description: "The client's stored statements, newest first",
			searchEnabled: false,
			showFiltersByDefault: false,
			clickAction: {
				type: 'navigate',
				path: '/statements/{id}',
			},
		},
	],
	paging: {
		defaultPageSize: 25,
		pageSizeOptions: [25, 50, 100],
	},
	filters: {
		activeFilters: [],
	},
	objectType: 'statement',
};
